import { render, staticRenderFns } from "./BookingMain.vue?vue&type=template&id=01c12557"
import script from "./BookingMain.vue?vue&type=script&lang=js"
export * from "./BookingMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c12557')) {
      api.createRecord('01c12557', component.options)
    } else {
      api.reload('01c12557', component.options)
    }
    module.hot.accept("./BookingMain.vue?vue&type=template&id=01c12557", function () {
      api.rerender('01c12557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/BookingMain.vue"
export default component.exports